import React from "react";
import Input from "../../../components/FormComponents/Input";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import { toastError, toastSuccess } from "../../../utils/toastUtils";
import { saveFile } from "../../../commonFunctions/fileFolderConfig";
import axiosInstance, { handleApiError } from "../../../services/axiosService";

const ExcelTemplateFileUpload = ({ templateId, templateName, templateFileId, onFileUploadSuccess }) => {
  const handleFileUpload = async (e) => {
    const uploadedFile = e.target.files[0];
    const fileName = uploadedFile?.name;

    const regex = /^[a-zA-Z0-9 _.-]+$/;
    if (!regex.test(fileName)) {
      toastError("Special characters not allowed in file name");
      return;
    }

    const formData = new FormData();
    formData.append("myFile", uploadedFile);
    formData.append("name", templateName);
    formData.append("id", templateId);

    try {
      const { data, message } = await axiosInstance.post(`/exceldoc-template`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      onFileUploadSuccess(data.template_id); // notify parent
      toastSuccess(message);
    } catch (err) {
      handleApiError(err);
    }
  };

  const handleDownloadFile = async () => {
    try {
      const response = await axiosInstance.get(`/template-file/${templateFileId}`, {
        responseType: "blob"
      });
      saveFile(response, templateFileId);
    } catch (err) {
      handleApiError(err);
    }
  };

  return (
    <div className="builder_form">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ display: "flex", gap: "8px" }}>
          <label className="builder_label">Select File</label>
          <label style={{ fontWeight: "700" }}>{templateFileId || "Template not added yet"}</label>
        </div>
        {templateFileId && <MaterialIcon name="download" onClick={handleDownloadFile} />}
      </div>
      <Input className="builder_input" type="file" onChange={handleFileUpload} />
    </div>
  );
};

export default ExcelTemplateFileUpload;
